import React, { FunctionComponent } from 'react';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { useHistory } from 'react-router-dom';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import styles from './MainBreadcrumbs.module.scss';
import { Typography } from '@material-ui/core';
import { _t } from 'app/utils/i18n';
import { useModal } from 'app/context/Modal';
import ErrorBoundary from '../ErrorBoundary';

export interface IPage {
  title: string;
  path?: string;
  state?: any;
}
interface Props {
  pages: any;
  compId?: string;
  isValueChange?: boolean;
}

const MainBreadcrumbs: FunctionComponent<Props> = ({
  pages,
  compId,
  isValueChange,
}) => {
  const { show, hide } = useModal();
  const { replace } = useHistory();
  const openModal = (page: IPage, isLastPage: boolean) => {
    if (isValueChange && !isLastPage) {
      show({
        message: _t(`basic:are_you_sure_you_want_to_cancel`),
        onOk: () => {
          replace(page?.path as any, page?.state);
          hide();
        },
      });
    } else {
      if (page?.path) replace(page?.path, page?.state);
    }
  };
  return (
    <ErrorBoundary>
      <div
        className={styles.MainBreadcrumbs}
        id={compId}
        data-testid="Breadcrumbs-testid"
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {pages?.filter(Boolean).map((page: IPage, index: number) => {
            return (
              <Typography
                component={page?.path ? 'a' : 'span'}
                key={index}
                color="inherit"
                style={page.path!==''?{ cursor: 'pointer' }:{}}
                onClick={() => openModal(page, index === pages?.length - 1)}
                data-testid={`pagelink-testid${index}`}
              >
                {page.title}
              </Typography>
            );
          })}
        </Breadcrumbs>
      </div>
    </ErrorBoundary>
  );
};

export default MainBreadcrumbs;
